
const MAPS_EVENT_CATEGORY = 'Locator';
const MAPS_EVENT_ACTION = 'DirectionsClick';
const LINK_EVENT_ACTION = 'WebsiteClick';

/*
* ga('send', 'event', [eventCategory], [eventAction], [eventLabel], [eventValue], [fieldsObject]);
 */
export const qaReportDirectionsClick = (locationTitle) => {
	if (!ga || !locationTitle) {
		return;
	}
	const reportingArgs = [
		'send',
		'event',
		MAPS_EVENT_CATEGORY,
		MAPS_EVENT_ACTION,
		locationTitle,
	];
	console.info('Locator: Google Directions Click', ...reportingArgs);
	ga(
		...reportingArgs,
	);
};

export const qaReportSiteClick = (locationTitle) => {
	if (!ga || !locationTitle) {
		return;
	}
	const reportingArgs = [
		'send',
		'event',
		MAPS_EVENT_CATEGORY,
		LINK_EVENT_ACTION,
		locationTitle,
	];
	console.info('Locator: Website Click', ...reportingArgs);
	ga(
		...reportingArgs,
	);
};



// WEBPACK FOOTER //
// ./src/utils/data/analytics.js